import { render, staticRenderFns } from "./AffirmContactUs.vue?vue&type=template&id=f265e1d4&"
import script from "./AffirmContactUs.vue?vue&type=script&lang=js&"
export * from "./AffirmContactUs.vue?vue&type=script&lang=js&"
import style0 from "./AffirmContactUs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports